import React from "react";
import NavBar1 from '../../components/Navbar1/NavBar1';
import Footer from '../../components/Footer/Footer'; 
import SideBar from '../../components/SideBar/SideBar';
import SpecificProduct from "../../components/SpecificProduct/SpecificProduct";

const Product  = ()=>{
    return (
       <>
        <NavBar1/>
        <SideBar>
            <Footer>

                <SpecificProduct/>

            </Footer>
        </SideBar>
       
       </>
    )
}

export default Product; 